import { FC } from 'react';
import { Box, Stack } from '@mui/material';
import { FieldDefinition, FieldDisplay } from 'src/components/field_display';

/**
 * FieldList Component
 *
 * Renders a list of label-value pairs with optional icons.
 * Used for displaying read-only information in a structured format.
 */
export const FieldList: FC<{
  fields: FieldDefinition[];
}> = ({ fields }) => {
  if (fields.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 1,
      }}
    >
      <Stack spacing={2}>
        {fields.map((field, index) => {
          return (
            <FieldDisplay key={index} field={field} variant='horizontal' />
          );
        })}
      </Stack>
    </Box>
  );
};
